<!-- BannerComponent.vue (Vue 2 兼容) -->
<template>
  <div class="banner-container">
    <el-carousel
      :interval="config['interval']"
      :height="config['listType'] === 'width' ? '200px' : '437.33px'"
      indicator-position="none"
    >
      <el-carousel-item v-for="(img, idx) in config['mediaUrls']" :key="idx">
        <el-image
          v-if="img['mediaType'] === 'image'"
          :class="config['listType'] === 'width' ? 'w-image' : 'h-image'"
          :src="img.mediaUrl"
          fit="contain">
        </el-image>
        <div v-else-if="img['mediaType'] === 'video'">
          <video controls class="preview-video">
            <source :src="img.mediaUrl" />
          </video>
        </div>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
export default {
  name: 'BannerComponent',
  props: {
    config: Object,
  },
  data() {
    return {

    }
  },
  watch: {
    config:{
      handler(newVal) {
        console.log(newVal);
      },
      deep: true
    },
  },
  mounted() {
    console.log(this.config);
  },
  methods: {

  },
}
</script>

<style scoped>
.banner-container {
  border-radius: 4px;
  margin: 10px 0;
}

.carousel-image {
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
}

.img-url {
  font-size: 12px;
  color: #888;
  text-align: center;
  padding-top: 5px;
}

.w-image{
  width: 320px;
  height: 200px
}

.h-image{
  width: 328px;
  height: 437.33px
}
</style>



// WEBPACK FOOTER //
// src/components/instrument/BannerComponent.vue